export default {
  SET_LOADING(state, value) {
    state.loading = value
  },

  SET_ERROR(state, error) {
    state.error = error
  },
  SET_MESSAGE(state, message) {
    state.message = message
  },
  
  SET_FACILITIES(state, data) {
    state.facilities = data.data
  },

  SET_FACILITY(state, facility) {
    state.facility = facility
  },

  SET_FILTERS(state, filters) {
    state.filters = { ...state.filters, ...filters }
  },

  SET_PAGINATION(state, data) {
    state.pagination = {
      total: data.total,
      current_page: data.current_page,
      last_page: data.last_page
    }
  },

  ADD_FACILITY(state, facility) {
    state.facilities.unshift(facility)
  },

  UPDATE_FACILITY(state, updatedFacility) {
    const index = state.facilities.findIndex(u => u.id === updatedFacility.id)
    if (index !== -1) {
      state.facilities.splice(index, 1, updatedFacility)
    }
  },

  DELETE_FACILITY(state, id) {
    state.facilities = state.facilities.filter(u => u.id !== id)
  },
  RESET_FACILITY(state) {
    state.facility = null
  },
}